﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251223

*/

'use strict';

import { getTableRows } from './ctssHtml.js';
import { getPromise, savePromise } from './ctssJQuery.js';
import { getMembersDDLAsync } from './snMembers.js';
import { getAppToken, setMenu } from './snSite.js';


const token = getAppToken();

/* private functions */

const changeRightsAsync = async (params = {}) => {
    const { id } = params;
    if (!id) {
        alert('id is a required param for snStaff.changeRightsAsync!');
    }
    const rights = {
        id: id,
        memberStats: {
            isAdmin: $(`#IsAdmin_${id}`).is(":checked"),
            isPastor: $(`#IsPastor_${id}`).is(":checked"),
            isStaff: $(`#IsStaff_${id}`).is(":checked")
        }
    };
    await saveRightsAsync({ rights });
    if (rights.memberStats.isAdmin === false &&
        rights.memberStats.isPastor === false &&
        rights.memberStats.isStaff === false) {
        /* Just removing from page is faster than going to server to refresh */
        const idxStaff = staff.findIndex(x => x.id === parseInt(id, 10));
        const name = staff[idxStaff].name;
        staff.splice(idxStaff, 1);
        $('#' + id).remove();
        members.push({ value: id, text: name });
        members.sort((a, b) => a.text.localeCompare(b.text)); /* sort aphabetically */
        setAddStaffDDL();
    }
}; 

const getStaffRow = (params) => {
    let row = '<tr id="' + params.data.id + '" >' +
        '<td class="col-md-2">' + params.data.name + '</td>' +
        '<td class="col-md-3">' + params.data.email + '</td>' +
        '<td class="col-md-2">' + params.data.phone + '</td>' +
        '<td class="col-md-1"><input id="IsAdmin_' + params.data.id +
        '" type="checkbox" class="k-checkbox" ';
    if (params.data.memberStats.isAdmin) {
        row += ' checked';
    }
    row += '><label class="k-checkbox-label" for="IsAdmin_' + params.data.id + '"></td>' +
        '<td class="col-md-1"><input id="IsPastor_' + params.data.id +
        '" type="checkbox" class="k-checkbox" ';
    if (params.data.memberStats.isPastor) {
        row += ' checked';
    }
    row += '><label class="k-checkbox-label" for="IsPastor_' + params.data.id + '"></td>' +
        '<td class="col-md-1"><input id="IsStaff_' + params.data.id +
        '" type="checkbox" class="k-checkbox" ';
    if (params.data.memberStats.isStaff) {
        row += ' checked';
    }
    row += '><label class="k-checkbox-label" for="IsStaff_' + params.data.id + '"></td>' +
        '<td class="col-md-2"> </td></tr > ';
    return row;
}

const initAddDlg = async () => {

    if (members.length === 0) {

        members = await getMembersDDLAsync();

        for (let i = 0; i < members.length; i++) { // Remove existing staff members
            if (staff.findIndex(x => x.id === parseInt(members[i].value, 10)) > -1) {
                members.splice(i, 1);
            }
        }
        setAddStaffDDL();
    }
    $('#btnDlgAddStaff').off('click').click(async () => {
        const name = $('#editChurchMember').val();
        if (name.length === 0) {
            $('#divAddDlgErrMsg')
                .text('Please enter a church member...')
                .removeClass('hidden');
            return;
        }
        const idxMember = members.findIndex(x => x.text === name);
        const idxStaff = staff.findIndex(x => x.name === name);
        if (idxStaff > -1) {
            $('#divAddDlgErrMsg')
                .text(name + ' is already a staff member...')
                .removeClass('hidden');
            return;
        }
        else if (idxMember === -1) {
            $('#divAddDlgErrMsg')
                .text(name + ' is not a registered church member...')
                .removeClass('hidden');
            return;
        } else {
            $('#addDlg').text('').modal('hide');
        }
        await saveRightsAsync({
            rights: {
                id: members[idxMember].value,
                memberStats: {
                    isAdmin: false,
                    isPastor: false,
                    isStaff: true
                }
            }
        }).then(async () => {
            staff = await getStaffDataAsync()
            refreshGrid();
        });
        return;
    });
}

const refreshGrid = () =>
    getTableRows({ arr: staff, fnGetRow: getStaffRow, gridNm: 'gridStaff' });

const saveRightsAsync = async (params) =>
    await savePromise({ url: 'ChurchStaff', data: params.rights });

const setAddStaffDDL = () => {
    $('#editChurchMember').kendoAutoComplete({
        dataSource: members.map((x) => x.text),
        placeholder: 'Select church member...'
    })
}

/* public functions */

let staff = [];
let members = [];

const getAdminsDDLDataAsync = async () =>
    await getPromise({ url: `ChurchStaff/AdminsDDL/${token.CG}` });

const getPastorsDDLDataAsync = async () =>
    await getPromise({ url: `ChurchStaff/PastorsDDL/${token.CG}` });

const getStaffDataAsync = async () =>
    await getPromise({ url: `ChurchStaff/${token.CG}` });

const initAsync = async () => {
    setMenu();
    try {
        staff = await getStaffDataAsync()
        refreshGrid();
        await initAddDlg();
        $('#gridStaff tbody').on('change', 'input[type=checkbox]',
            async (e) => {
                const id = e.target.closest('tr').id;
                await changeRightsAsync({ id });
            });
    }
    catch (error) { }
};


export {
    getAdminsDDLDataAsync,
    getStaffDataAsync,
    getPastorsDDLDataAsync
};

window.snStaff = {
    initAsync
};
